import React from 'react';
import { IconExchanges16, Inline, Link, Text } from '@stitch-fix/mode-react';
export const ReturnExchangeItem = ({
  returnHeading,
  returnBody,
  orderId,
  returnInProgress
}: {
  returnHeading: string;
  returnBody: string;
  orderId: string;
  returnInProgress?: boolean;
}) => !returnInProgress ? <>
      <Text mt={0} setting="title-xsmall">
        {returnHeading}
      </Text>
      <Text mb={1} setting="body-medium">
        {returnBody}&nbsp;
        <Link rel="noopener noreferrer" href="https://support.stitchfix.com/hc/en-us/articles/203484970-Returns">
          Return policy
        </Link>
      </Text>
      <Inline vAlign="center" spacing={0.5}>
        <IconExchanges16 title="exchange" />
        <Link href={`/return-exchange?order_number=${orderId}`}>
          <Text setting="body-medium">Return or replace items</Text>
        </Link>
      </Inline>
    </> : null;